import {Controller} from "@hotwired/stimulus"
import L from "leaflet"
import {Turbo} from "@hotwired/turbo-rails"

export default class extends Controller {
    static values = {
        markerIcon: String,
        markerIcon2x: String,
        markerShadow: String,
        rocks: Array,
    }

    declare markerIconValue: string
    declare markerParkingValue: string
    declare markerIcon2xValue: string
    declare markerParking2xValue: string
    declare markerShadowValue: string
    declare rocksValue: { id: string, name: string, latitude: number, longitude: number, slug: string }[]

    private map: L.Map | null = null

    connect(): void {
        const el = this.element as HTMLElement
        const startWhenReady = () => {
            if (el.offsetHeight > 100) { // 100px als Schwellenwert für aktives CSS
                this.initializeMap(el)
            } else {
                requestAnimationFrame(startWhenReady)
            }
        }
        startWhenReady()
    }

    private initializeMap(el: HTMLElement): void {
        if (this.map || !this.rocksValue) return
        this.map = L.map(el, {
            zoomControl: true,
            fadeAnimation: false
        })

        L.tileLayer('/map_tiles/{z}/{x}/{y}.png', {
            maxZoom: 19,
            minZoom: 2,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> Mitwirkende'
        }).addTo(this.map)

        const rockIcon = L.icon({
            iconUrl: this.markerIconValue,
            iconRetinaUrl: this.markerIcon2xValue,
            shadowUrl: this.markerShadowValue,
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowAnchor: [12, 41]
        })

        const markerGroup: L.Marker[] = []

        this.rocksValue.forEach(rock => {
                if (rock.latitude && rock.longitude) {
                    const marker = L.marker([rock.latitude, rock.longitude], {icon: rockIcon})
                        .addTo(this.map!)
                        .bindTooltip(rock.name, {
                            permanent: true,
                            direction: 'top',
                            offset: [0, -37],
                            className: 'map-label'
                        })
                    marker.on('click', () => {
                            Turbo.visit(`/rocks/${rock.id}-${rock.slug}`, {frame: "main-content"})
                        }
                    )
                    markerGroup.push(marker)
                }
            }
        )

        if (markerGroup.length > 0) {
            const featureGroup = L.featureGroup(markerGroup);
            this.map.invalidateSize();
            setTimeout(() => {
                if (this.map) {
                    this.map.fitBounds(featureGroup.getBounds(), {
                        padding: [50, 50],
                        animate: false
                    });
                }
            }, 100);
        }
    }

    disconnect()
        :
        void {
        if (this.map
        ) {
            this.map.remove()
            this.map = null
        }
    }
}
